<template>
  <div>
    <table class="hours-table">
      <thead>
        <th class="project-header"><div>Projetos <input class="filter-input" type="text"  v-model="search"/> </div></th>
        <template v-for="(weekDay, index) in weekDays" :key="index">
          <th class="day-header">{{ weekDay.name }} <br>
            <div class="week-day-date">{{ weekDay.formattedDate }}</div>
          </th>
        </template>
      </thead>
      <tbody>

        <template v-for="(project, index) in filteredProjects" :key="index">
          <tr class="projects-column">
            <td class="project-name" @click="toggleAccordion(project)">{{ project.name }}</td>
            <td v-for="(workedHours, index) in project.workedHours" :key="index" :workedHours="workedHours"
              class="input-column">
              <input type="text" v-model="workedHours.value" class="hours-input"
                @change="defineUpdatingProject(project, $event, workedHours.date);">
            </td>
          </tr>
          <tr v-for="(phase, index) in project.phases" :key="index" :phase="phase" class="table projects-column"
            :class="{ 'project-phases-is-closed': isProjectOpen(phase.id) }">
            <td> {{ phase.name }}</td>
            <td v-for="(workedHours, index) in phase.workedHours" :key="index" :workedHours="workedHours"
              class="phase-input-column">
              <input type="text" v-model="workedHours.value" class="hours-input"
                @change="defineUpdatingPhase(phase, project, $event, workedHours.date);">
            </td>
          </tr>
        </template>
      </tbody>
      <tr class="projects-column" style="position: sticky; bottom: -1px;">
        <td class="project-name" style="cursor: default; ">TOTAL</td>
        <td v-for="(totalForDay, index) in totalForDays" :key="index" :totalForDay="totalForDay" class="input-column">
          <input type="text" :value="totalForDay.value" class="hours-input" disabled="true"
            style="background-color: rgb(236, 236, 236);">
        </td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts">
import IProject from '@/interfaces/IProject';
import IWeekDay from '@/interfaces/IWeekDay';
import IProjectPhase from '@/interfaces/IProjectPhase';
import IProjectWorkedHours from '@/interfaces/IProjectWorkedHours';
import IPhaseWorkedHours from '@/interfaces/IPhaseWorkedHours';
import ITotalWorkedHours from '@/interfaces/ITotalWorkedHours';
import { getWebObjectsAppUrl } from '@/utils/UrlUtils';
import { defineComponent } from 'vue';
import { ref } from 'vue';

declare global {
  interface Window { showError: any; }
}

export default defineComponent({
  name: 'TabelaDeHoras',
  data:() => {
    return {
      search: '',
      projects: [] as IProject[],
      weekDays: [] as IWeekDay[],
      currentProject: {} as IProject,
      updatingProject: {} as IProject,
      updatingDate: {} as IWeekDay,
      updatingPhase: {} as IProjectPhase,
      updatingProjectWorkedHour: {} as IProjectWorkedHours,
      updatingPhaseWorkedHour: {} as IPhaseWorkedHours,
      totalForDays: {} as ITotalWorkedHours[],
    }
  },
  created() {
    this.fetchData();
  },
  computed: {
    filteredProjects() {
      return this.projects.filter(project => project.name.toLowerCase().includes(this.search.trim().toLowerCase()))
    }
  },
  methods: {
    toggleAccordion(project: IProject) {
      if (this.currentProject.id == project.id) {
        this.currentProject = {} as IProject
      } else {
        this.currentProject = project
      }
    },
    isProjectOpen(phaseId: number) {
      if (this.currentProject.name != undefined) {
        var isOpen = this.currentProject.phases.find((phase) => phase.id == phaseId)
        return !isOpen
      }
      return true
    },
    async defineUpdatingProject(project: IProject, event: Event, date: Date) {
      this.updatingPhaseWorkedHour = {} as IPhaseWorkedHours;
      this.updatingProject = project
      this.updatingDate.date = date

      var projectWorkedHour = project.workedHours.find(wh => wh.projectId == project.id && wh.date == date)
      var totalForDay = this.totalForDays.find(t => t.date == date)

      if (projectWorkedHour != null) {
        this.updatingProjectWorkedHour = projectWorkedHour
      }

      var newProjectWorkedHours = "";
      var newTotalForDay = "";

      await this.sendToDOit().then(async response => {
        if (!response.ok) {
          throw new Error(await response.text())
        } return response.text()
      })
        .then((response) => {
          var responseJSON = JSON.parse(response.replace("\n", ""))
          newProjectWorkedHours = responseJSON.projectWorkedHours,
            newTotalForDay = responseJSON.totalForDay

          if (projectWorkedHour != null) {
            projectWorkedHour.value = newProjectWorkedHours
          }

          if (totalForDay != null) {
            totalForDay.value = newTotalForDay
          }

          if (newProjectWorkedHours == "00:00") {
            this.fetchData();
          }
        })
        .catch((error) => {
          this.fetchData();
          window.showError(error.message)

        })
    },
    async defineUpdatingPhase(phase: IProjectPhase, project: IProject, event: Event, date: Date) {
      this.updatingPhase = phase
      this.updatingProject = project
      this.updatingDate.date = date

      var projectWorkedHour = project.workedHours.find(wh => wh.projectId == project.id && wh.date == date)
      var phaseWorkedHour = phase.workedHours.find(wh => wh.phaseId == phase.id && wh.projectId == project.id && wh.date == date)
      var totalForDay = this.totalForDays.find(t => t.date == date)

      if (phaseWorkedHour != null) {
        this.updatingPhaseWorkedHour = phaseWorkedHour
      }

      var newProjectWorkedHours = "";
      var newPhaseWorkedHours = "";
      var newTotalForDay = "";


      await this.sendToDOit().then(async response => {
        if (!response.ok) {
          throw new Error(await response.text())
        } return response.text()
      })
        .then((response) => {
          var responseJSON = JSON.parse(response.replace("\n", ""))
          newProjectWorkedHours = responseJSON.projectWorkedHours
          newPhaseWorkedHours = responseJSON.phaseWorkedHours
          newTotalForDay = responseJSON.totalForDay
        }
      ).catch((error) => {
          this.fetchData();
          window.showError(error.message)

        })

      if (projectWorkedHour != null) {
        projectWorkedHour.value = newProjectWorkedHours
      }

      if (phaseWorkedHour != null) {
        phaseWorkedHour.value = newPhaseWorkedHours
      }

      if (totalForDay != null) {
        totalForDay.value = newTotalForDay
      }
    },
    fetchData() {
      const url = getWebObjectsAppUrl(window.location.href) + "/ra/Projects.json?hoursDashboard=true";

      return fetch(url, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(response => response.json())
        .then(data => {
          this.projects = ref(data.projects) as IProject[];
          this.weekDays = data.weekDays as IWeekDay[];
          this.totalForDays = data.totalOnDay as ITotalWorkedHours[];
        })
    },
    sendToDOit: function () {
      const url = getWebObjectsAppUrl(window.location.href) + "/ra/Projects/";

      return fetch(url, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json'
        }
        ),
        body: JSON.stringify(this.$data)
      }
      )
    }
  }
});

</script>

<style>
.projects-column {
  width: auto;
  text-align: left;
}

.project-name {
  font-weight: bold;
  cursor: pointer;
  background-color: #FFFFD1;
  text-align: left;
  padding-left: 10px;
}

.project-phases-is-closed {
  display: none;
}

.project-header {
  background-color: #FFBD7B;
  text-align: left;
  width: auto;
  height: 35px;
  padding-left: 10px;
  position: sticky;
  top: 0;
}

.day-header {
  background-color: #FFBD7B;
  text-align: center;
  width: 85px;
  padding-left: 5px;
  padding-right: 5px;
  position: sticky;
  top: 0;
}

.project-line {
  background-color: #FFFFD1;
  height: 40px;
  text-align: left;
  padding-left: 10px;
}

.input-column {
  background-color: #FFFFD1;
  height: 40px;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.phase-line {
  height: 40px;
  text-align: left;
  padding-left: 10px;
}

.phase-input-column {
  height: 40px;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.hours-input {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 3px;
  border: 1px solid #d9d8d8;
  width: 60px;
  height: 25px;
  text-align: center;
  align-self: left;
  align-items: left;
  align-content: left;
}

.filter-input {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 3px;
  border: 1px solid #d9d8d8;
  width: 200px;
  height: 20px;
  text-align: left;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.hours-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: -webkit-fill-available;
  border: 1px
}

.hours-table td {
  border: 1px solid #dbdbdb;
  border-width: 0 0 1px;
  padding-left: 10px;
}

.week-day-date {
  font-size: 10px;
  font-weight: normal;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>
@/interfaces/IPhaseWorkedHours